export const popUpHeader = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const popUpBody = {
  marginBottom: "20px",
  textTransform: "none",
  fontSize: "13px",
  fontFamily: "Proxima Nova",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  lineHeight: "25px",
  letterSpacing: "0px",
};

export const popUpContent = {
  border: "3px solid #87CEEB",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
